<template>
  <div style="display: flex">
    <el-form label-position="right" label-width="135px" style="display: flex;">
      <div v-for="(item, index) in upElementBlocks" :key="index" class="section form-column" :style="{width: item.width + 'px'}">
        <span class="title">{{ item.title }}</span>
        <template v-for="elementName in item.elementNames">
          <slot :name="elementName" />
          <template v-if="elementName === 'jobNo'">
            <slot name="saleProductCode" />
            <slot name="fullOrInside" />
          </template>
        </template>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'BasicTabUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true }
  },
  computed: {
    upElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 1 && !p.hide)
    }
  }
}
</script>
